import { render, staticRenderFns } from "./EditLoadingDetails.vue?vue&type=template&id=0c3a01ac"
import script from "./EditLoadingDetails.vue?vue&type=script&lang=js"
export * from "./EditLoadingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports